export default __webpack_public_path__ + "static/media/ic_arbitrum_hover_16.d779b479.svg";